<template>
  <span class="velodrom-loader" role="img" aria-label="Loading Velodrom bike builder">
    <img :src="logo" alt="" class="velodrom-loader-mark" />
  </span>
</template>
<script>
import { appBase } from '@/utils/basePath';
export default { computed: { logo() { return `${appBase}/img/velodrom-v.svg`; } } };
</script>
<style scoped>
.velodrom-loader { display:inline-flex; align-items:center; justify-content:center; width:160px; height:160px; perspective:650px; }
.velodrom-loader-mark { width:88px; height:76px; object-fit:contain; animation:velodrom-turn 2.4s ease-in-out infinite; filter:drop-shadow(4px 5px 0 #b8bab2); }
@keyframes velodrom-turn { 0% { transform:rotateY(0deg) rotateX(-8deg); } 100% { transform:rotateY(360deg) rotateX(-8deg); } }
@media(prefers-reduced-motion:reduce) { .velodrom-loader-mark { animation:none; filter:none; } }
</style>
